import { TextBox } from "@progress/kendo-react-inputs";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import sk from "../../localization/sk.json";
import { GridFilterCell } from "@progress/kendo-react-grid";
import { NUMERIC_OPS } from "../dialogs/DialogFilterExtended";

/**
 * Filtrovacia bunka pre cisla formatovane ako string (napr. pre ucely operatora IN)
 * @param {*} props 
 */
const StringNumericFilterCell = (props) => {
  const { value, onChange, operators, operator, field, thProps } = props;
  const operatorValue = (operators && operators.find((x) => x.operator === operator)) || null;

  const handleOperatorChange = (e) => {
    let newValue = value;
    if ((operator === "in" || operator === "notin") && (e.target.value.operator !== "in" || e.target.value.operator !== "notin")) {
      newValue = null;
    }
    onChange({
      value: newValue,
      operator: e.target.value.operator,
      nativeEvent: e.nativeEvent,
      syntheticEvent: e.syntheticEvent,
    });
  };

  const handleChange = (event) => {
    if (/^(\d+[,.]?)*$/gm.test(event.value)) {
      onChange({
        value: event.value,
        operator: operator,
        nativeEvent: event.nativeEvent,
        syntheticEvent: event.syntheticEvent,
      });
    }
  };

  const element = (
    (operator === "in" || operator === "notin") ?
      <div className={"k-filtercell"}>
        <div className={"k-filtercell-wrapper"}>
          <TextBox
            name={field}
            onChange={handleChange}
            value={value || ""}
          />

          <div className={"k-filtercell-operator"}>
            <DropDownList className={"k-dropdown-operator"} data={NUMERIC_OPS} textField={"text"} dataItemKey={"operator"} value={operatorValue} onChange={handleOperatorChange} iconClassName={"k-icon k-font-icon k-i-filter"} popupSettings={{ width: "" }} />
            <span>&nbsp;</span>
            <button
              style={{ visibility: value ? "visible" : "hidden" }}
              className={`k-button k-button-md k-button-solid k-button-solid-base k-rounded-md k-icon-button ${value ? "k-clear-button-visible" : "k-disabled"}`}
              title={sk.grid.filterClearButton}
              disabled={!value}
              onClick={(event) => {
                event.preventDefault();
                onChange({
                  value: "",
                  operator: "",
                  syntheticEvent: event,
                });
              }}
            >
              <span className="k-icon k-font-icon k-i-filter-clear" />
            </button>
          </div>
        </div>
      </div>
      :
      <GridFilterCell {...props}
        onChange={onChange}
        filterType={'numeric'}
        operators={NUMERIC_OPS}
      />
  );

  return thProps ? (<HeaderThElement {...thProps} > {element}</HeaderThElement >) : element;
};

export default StringNumericFilterCell;